"use client";

import type { Networkish, SupSingleVaultV3 } from "@/types";
import React, { useCallback, useMemo } from "react";

import UiWidgetChainSelectorMultiSelect from "@/components/Ui/Widget/ChainSelector/MultiSelect";
import LayoutSidebarFiltersAtomHeader from "@/components/Grid/Bar/Filters/Atom/Header";
import { useStoredData, useStoredDataDispatch } from "@/store/Context";

interface LayoutSidebarFiltersChainProps {
  vaults?: SupSingleVaultV3[];
}
export default function LayoutSidebarFiltersChain({ vaults }: LayoutSidebarFiltersChainProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const supportedChains = useMemo(() => [...new Set(vaults?.flatMap(vault => vault.chain.id))], [vaults]);

  const selectedChains = useMemo(() => {
    const filterValues = storedData.filters.find(storedFilter => storedFilter.name === "chain");
    return (filterValues ? filterValues.values : []) as Networkish[];
  }, [storedData.filters]);

  const handleChainSelection = useCallback(
    (chain: Networkish) => {
      const updatedChainsList = selectedChains.includes(chain) ? [...selectedChains.filter(chainId => chainId !== chain)] : [...selectedChains, chain];
      storedDispatch({ type: "setFilter", filter: { name: "chain", values: updatedChainsList } });
    },
    [selectedChains, storedDispatch]
  );

  return (
    <LayoutSidebarFiltersAtomHeader name="chain">
      <div className="mt-[16px] space-y-[16px]">
        <UiWidgetChainSelectorMultiSelect selectedChains={selectedChains} chainList={supportedChains} onClick={handleChainSelection} />
      </div>
    </LayoutSidebarFiltersAtomHeader>
  );
}
